import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { MessageResponse } from '../_models/responses';

export interface Notice {
  id?: number;
  propertyId: number;
  unit_number: number;
  dateVisible: string;
  shortDescription: string;
  longDescription: string;
}

@Injectable({ providedIn: 'root' })
export class NoticeService {
  constructor(private http: HttpClient) {}

  getNoticesByPropertyId(propertyId: number) {
    return this.http.get<Notice[]>(`${environment.apiUrl}/api/notice/property/${propertyId}`);
  }

  getNoticesByPropertyIdAndUnitNumber(propertyId: number, unitNumber: number) {
    return this.http.get<Notice[]>(`${environment.apiUrl}/api/notice/property/${propertyId}/unit/${unitNumber}`);
  }

  getNotice(noticeId: number) {
    return this.http.get<Notice>(`${environment.apiUrl}/api/notice/${noticeId}`);
  }

  createNotice(request: any) {
    let header = new HttpHeaders();
    header = header.append('content-type', 'application/json');

    return this.http.post<MessageResponse>(`${environment.apiUrl}/api/notice`, request, { headers: header });
  }

  updateNotice(noticeId: number, request: any) {
    return this.http.put<MessageResponse>(`${environment.apiUrl}/api/notice/${noticeId}`, request);
  }

  deleteNotice(noticeId: number) {
    return this.http.delete<MessageResponse>(`${environment.apiUrl}/api/notice/${noticeId}`);
  }
}
